// localStorage (or sessionStorage) that never throws: private windows and blocked storage just forget (90-test-hooks.md).
export function readJson<T>(key: string, store?: Storage): T | undefined {
  try {
    const raw = (store ?? localStorage).getItem(key);
    return raw === null ? undefined : (JSON.parse(raw) as T);
  } catch {
    return undefined;
  }
}

export function writeJson(key: string, value: unknown, store?: Storage): void {
  try {
    if (value === undefined) (store ?? localStorage).removeItem(key);
    else (store ?? localStorage).setItem(key, JSON.stringify(value));
  } catch {
    // storage refused: kept for this page only by the caller's own state
  }
}
